import api from './client';

const toParams = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    searchParams.set(key, String(value));
  });
  const suffix = searchParams.toString();
  return suffix ? `?${suffix}` : '';
};

// Sigma Rules
export const listSigmaRules = async (params) => {
  const { data } = await api.get(`/api/sigma-rules/${toParams(params)}`);
  return data;
};

export const createSigmaRule = async (payload) => {
  const { data } = await api.post('/api/sigma-rules/', payload);
  return data;
};

export const updateSigmaRule = async (id, payload) => {
  const { data } = await api.patch(`/api/sigma-rules/${id}/`, payload);
  return data;
};

export const deleteSigmaRule = async (id) => {
  await api.delete(`/api/sigma-rules/${id}/`);
};

export const validateSigmaRule = async (id) => {
  const { data } = await api.post(`/api/sigma-rules/${id}/validate/`, {});
  return data;
};

export const listSigmaRuleVersions = async (id) => {
  const { data } = await api.get(`/api/sigma-rules/${id}/versions/`);
  return data;
};

export const testSigmaRule = async (id, payload = {}) => {
  const { data } = await api.post(`/api/sigma-rules/${id}/test/`, payload);
  return data;
};

export const promoteSigmaRule = async (id, payload = {}) => {
  const { data } = await api.post(`/api/sigma-rules/${id}/promote/`, payload);
  return data;
};

// Policy Gates
export const listPolicyGates = async (params) => {
  const { data } = await api.get(`/api/policy-gates/${toParams(params)}`);
  return data;
};

export const createPolicyGate = async (payload) => {
  const { data } = await api.post('/api/policy-gates/', payload);
  return data;
};

export const updatePolicyGate = async (id, payload) => {
  const { data } = await api.patch(`/api/policy-gates/${id}/`, payload);
  return data;
};

export const deletePolicyGate = async (id) => {
  await api.delete(`/api/policy-gates/${id}/`);
};

export const evaluatePolicyGates = async (payload = {}) => {
  const { data } = await api.post('/api/policy-gates/evaluate/', payload);
  return data;
};

export const checkPolicyGatesForCi = async (payload = {}) => {
  const { data } = await api.post('/api/policy-gates/ci-check/', payload);
  return data;
};

// Identity Config
export const getIdentityConfig = async () => {
  const { data } = await api.get('/api/identity-config/');
  return data;
};

export const updateIdentityConfig = async (payload) => {
  const { data } = await api.post('/api/identity-config/', payload);
  return data;
};

export const getIdentityProvisionPreview = async () => {
  const { data } = await api.get('/api/identity-config/provision-preview/');
  return data;
};

export const getIdentityOidcAuthorizeUrl = async (params = {}) => {
  const { data } = await api.get(`/api/identity-config/oidc-authorize-url/${toParams(params)}`);
  return data;
};

export const runIdentityScimProvision = async (payload = {}) => {
  const { data } = await api.post('/api/identity-config/scim-provision/', payload);
  return data;
};

// Observability
export const getObservability = async (params) => {
  const { data } = await api.get(`/api/observability/${toParams(params)}`);
  return data;
};

export const updateObservability = async (payload) => {
  const { data } = await api.post('/api/observability/', payload);
  return data;
};

export const runObservabilityTraceCheck = async () => {
  const { data } = await api.get('/api/observability/trace-check/');
  return data;
};

// Supply Chain
export const getSupplyChainOverview = async (params) => {
  const { data } = await api.get(`/api/supply-chain/${toParams(params)}`);
  return data;
};

export const signSupplyChainArtifact = async (artifactId) => {
  const { data } = await api.post('/api/supply-chain/sign-artifact/', { artifact: artifactId });
  return data;
};

export const verifySupplyChainArtifact = async (artifactId) => {
  const { data } = await api.post('/api/supply-chain/verify-artifact/', { artifact: artifactId });
  return data;
};

export const attestSupplyChainArtifact = async (payload = {}) => {
  const { data } = await api.post('/api/supply-chain/attest-artifact/', payload);
  return data;
};

export const verifySupplyChainAttestation = async (payload = {}) => {
  const { data } = await api.post('/api/supply-chain/verify-attestation/', payload);
  return data;
};

export const getSupplyChainAuditChain = async (params = {}) => {
  const { data } = await api.get(`/api/supply-chain/audit-chain/${toParams(params)}`);
  return data;
};

export const ingestSbomToSupplyChain = async (payload) => {
  const { data } = await api.post('/api/supply-chain/ingest-sbom/', payload);
  return data;
};

// Intel TAXII sync
export const syncTaxiiFeed = async (payload = {}) => {
  const { data } = await api.post('/api/intel-feeds/sync-taxii/', payload);
  return data;
};

export const correlateIntelFeed = async (params = {}) => {
  const { data } = await api.get(`/api/intel-feeds/correlate/${toParams(params)}`);
  return data;
};
